import { areRequiredFieldsFilled } from '@common/utils';
import { UseFormReturn } from 'react-hook-form';
import { CarrierSubmissionFormValues } from './useCarrierSubmissionForm';

export function useAllFieldsFilled(methods: UseFormReturn<CarrierSubmissionFormValues>): boolean {
  const values = methods.watch();
  return areRequiredFieldsFilled(values as Record<string, unknown>) && methods.formState.isValid;
}
